import {NgxLoggerLevel} from 'ngx-logger';
import {LogLevel} from '@azure/msal-browser';

export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  environment: '',
  loggingLevel: NgxLoggerLevel.WARN,
  msalLoggingLevel: LogLevel.Warning,
  authority: 'https://login.microsoftonline.com/common',
  azureClientId: '2dafdbbc-2ec9-4ab1-9d0b-d50f0ecd16b9',
  protectedResourceMap: [
    ['https://graph.microsoft.com/v1.0', ['User.Read']],
    ['/api/v1/Environment', null], // unprotected route have null scope
    ['/api/*', ['api://2dafdbbc-2ec9-4ab1-9d0b-d50f0ecd16b9/Api.Read']],
    // ... other scopes
  ],
  apiBaseUrl: window.location.origin,
  appInsights: {
    instrumentationKey: '3f4896ba-7d9a-4571-834d-1ecc99b45e57',
  },
};
